module.exports = __webpack_public_path__ + "static/img/logo.c2eb38c7.png";